import React, { useState } from "react";
import { format } from "date-fns";

import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography
} from "@mui/material";
import { ChevronRight, Circle } from "@mui/icons-material";

import { CheckIcon, DollarIcon, StreamsIcon, TrendUpIcon } from "../../../components/icons";
import { activity, ActivityProps } from "../../../data/pilot-activity";

import { paginate } from '../../../utils/paginate';
import { PilotProps } from "../types/view-pilot";

interface PilotActivityProps {
  pilot: PilotProps | null;
}

export const PilotActivity: React.FC<PilotActivityProps> = ({ pilot }) => {
  const [page, setPage] = useState(1);
  const [perPage] = useState(4);

  const paginated = paginate(activity, page, perPage);

  console.log({ pilot });

  const getActivityIcon = (activityType: string) => {
    switch (activityType) {
      case 'checklist-complete':
        return (
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            sx={{
              padding: 1,
              width: 32,
              height: 32,
              mr: 12,
              borderRadius: '50%',
              bgcolor: '#4BA66340'
            }}>
              <CheckIcon color={'success'} sx={{ fontSize: 18 }} />
          </Box>
        );
      case 'assignment-complete':
        return (
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            sx={{
              padding: 1,
              width: 32,
              height: 32,
              borderRadius: '50%',
              bgcolor: '#0000FF26'
            }}>
              <StreamsIcon color={'info'} sx={{ fontSize: 18 }} />
          </Box>
        );
      case 'payment-received':
        return (
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            sx={{
              padding: 1,
              width: 32,
              height: 32,
              mr: 12,
              borderRadius: '50%',
              bgcolor: '#4BA66340'
            }}>
              <DollarIcon color={'success'} sx={{ fontSize: 18 }} />
          </Box>
        );
      default:
        return (
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            sx={{
              padding: 1,
              width: 32,
              height: 32,
              mr: 12,
              borderRadius: '50%',
              bgcolor: '#0000FF26'
            }}>
              <CheckIcon color={'info'} sx={{ fontSize: 18 }} />
          </Box>
        );
    }
  };

  if (!pilot) return null;

  return (
    <Box sx={{ p: 1, minHeight: "auto" }}>
      <Grid container>
        {/* Pilot Activity */}
        <Grid size={12}>
          <Card sx={{ boxShadow: 0, height: "100%" }}>
            <CardContent>
              <Box
                display={'flex'}
                alignItems={'center'}
                sx={{ pb: '8px', borderBottom: 1, borderColor: 'divider', mb: '8px' }}
                gap={'4px'}>
                <TrendUpIcon color="disabled" sx={{ fontSize: 20 }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Activity Timeline
                </Typography>
              </Box>

              {activity && paginated?.map((pa: ActivityProps) => {
                return (
                  <Box key={pa.id} sx={{ borderBottom: '1px solid', padding: 2, borderColor: 'divider' }}>
                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                      <Grid container spacing={2}>
                        <Grid size={1}>
                          {getActivityIcon(pa.type)}
                        </Grid>
                        <Grid size={11}>
                          <Box>
                            <Typography variant={'subtitle2'} sx={{ fontWeight: 600 }}>{pa.title}</Typography>
                            <Typography variant={'caption'}>{pa.event.name} - {pa.notes}</Typography>
                          </Box>

                          <Box display={'flex'} sx={{ mt: .8 }} alignItems={'center'} gap={.4}>
                            <Typography variant={'caption'}>{format(new Date (pa.date), 'dd/MM/yyyy')}</Typography>
                            <Circle sx={{ fontSize: '4px' }} />
                            <Typography variant={'caption'}>{pa.time}</Typography>
                          </Box>
                        </Grid>
                      </Grid>
                      <IconButton>
                        <ChevronRight sx={{ fontSize: 24 }} />
                      </IconButton>
                    </Box>
                  </Box>  
                );
              })}

              <Box sx={{ mt: 2 }}>
                <Box display={'flex'} alignItems={'center'} gap={.4}>
                  <Typography sx={{ cursor: 'pointer', fontWeight: 600 }} variant={'subtitle1'}>Page:</Typography>
                  {[...Array(Math.ceil(activity.length / perPage)).keys()].map(pg => (
                  <Box
                    key={pg}
                    onClick={() => setPage(pg + 1)}
                    sx={{
                      bgcolor: page === pg + 1 ? '#724E41' : '#FFF',
                      borderRadius: 1,
                      cursor: 'pointer',
                      px: 1.6,
                      py: .4,
                      fontSize: 14,
                      fontWeight: page === pg + 1 ? 500 : 600,
                      color: page === pg + 1 ? '#FFF' : '#000',
                      transition: 'all .4s ease'
                    }}>
                      <Typography sx={{ cursor: 'pointer' }} variant={'h6'}>{pg + 1}</Typography>
                  </Box>
                  ))}
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
